/* iter87.199.99 — Shared platform consent helper.

Persists the user's one-time acceptance of TCR platform T&C + 18+
consent in localStorage so subsequent consent gates (rivalry creation
Step 0, magic-link join, placeholder claim, Pro+ Clerk sign-up) can
auto-skip the modal for someone who already agreed. Audit trail is
STILL stamped onto every league doc on the backend (iter87.199.69),
so compliance-record-of-truth is unaffected — this is a UX niceness
only.

Privacy note (per operator directive 2026-02-24, Path A over Path B):
we deliberately DO NOT persist consent server-side beyond the
per-league stamp. localStorage is the client-side flag; if a user
clears it they'll be prompted once and re-accept. Zero blast radius,
no additional PII at rest.

Shape:
    {
      age: true,
      tc: true,
      version: "v1",
      accepted_at: "2026-02-24T…Z",
    }
*/

const KEY = "tcr.platform_consent";
export const PLATFORM_CONSENT_VERSION = "v1";

export function hasPlatformConsent() {
    try {
        const stored = JSON.parse(localStorage.getItem(KEY) || "null");
        return !!(
            stored
            && stored.age === true
            && stored.tc === true
            && stored.version === PLATFORM_CONSENT_VERSION
        );
    } catch {
        return false;
    }
}

export function readPlatformConsent() {
    try {
        return JSON.parse(localStorage.getItem(KEY) || "null");
    } catch {
        return null;
    }
}

export function recordPlatformConsent() {
    try {
        localStorage.setItem(KEY, JSON.stringify({
            age: true, tc: true,
            version: PLATFORM_CONSENT_VERSION,
            accepted_at: new Date().toISOString(),
        }));
    } catch {
        /* localStorage may be unavailable (Safari private mode,
           quota, disabled) — no-op. Downstream flows still work,
           user just sees the modal again next time. */
    }
}

export function clearPlatformConsent() {
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
